import React from 'react';
import { useSimulatorRoutes } from 'hooks';
import { isPresentedList } from 'utils/collection';
import { EarnedRewardDto } from '@peartherapeutics/hylia-api-client';
import moment from 'moment';
import WidgetWrapper from '../Widgets/WidgetWrapper';
import {
  BlockTop,
  BlockMiddleEmpty,
  BlockMiddleTable,
  BlockBottom,
} from '../Widgets/Blocks';
import { CellHeader, Cell, Row, Heading } from '../Widgets/TableComponents';
import { VerticalScrollbar } from '../Widgets/CustomScrollbars';
import styles from './styles.module.scss';

interface IWidgetRewardsProps {
  rewards: EarnedRewardDto[];
  isInAppCm: boolean;
  total: string;
  isProcessing: boolean;
}

const WidgetRewards = (props: IWidgetRewardsProps) => {
  const { rewards, total, isProcessing, isInAppCm } = props;
  const routes = useSimulatorRoutes();

  /**
   * Sorts earned rewards by date.
   * @param a An earned reward
   * @param b An earned reward
   * @return a number
   */
  function byDate(a: EarnedRewardDto, b: EarnedRewardDto) {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  }

  return (
    <WidgetWrapper testId="widget-rewards" ariaLabel="Rewards Earned Widget">
      <BlockTop
        title={isProcessing ? '' : `${total}`}
        subtitle="Rewards Earned"
      />

      {isPresentedList(rewards) ? (
        <BlockMiddleTable>
          <Heading>
            <Row>
              <CellHeader externalClasses={styles.date}>Date</CellHeader>
              <CellHeader externalClasses={styles.type}>Type</CellHeader>
              <CellHeader>Amount</CellHeader>
            </Row>
          </Heading>

          <VerticalScrollbar
            listLength={rewards.length}
            maximumItemsToHideScrollbar={4}
          >
            {rewards.sort(byDate).map((reward, idx) => {
              const rowKey = `reward-${idx}`;

              return (
                <Row key={rowKey}>
                  <Cell externalClasses={styles.date}>
                    {moment(reward.date).format('l')}
                  </Cell>
                  <Cell externalClasses={styles.type}>{reward.type}</Cell>
                  <Cell>
                    {isInAppCm && reward?.amount !== '$0'
                      ? reward.amount
                      : 'Virtual Reward'}
                  </Cell>
                </Row>
              );
            })}
          </VerticalScrollbar>
        </BlockMiddleTable>
      ) : (
        <BlockMiddleEmpty content="Rewards can be earned through completing lessons and negative drug screens." />
      )}

      <BlockBottom
        link={routes.PATIENT_DASHBOARD_REWARDS}
        text="Go To Rewards"
      />
    </WidgetWrapper>
  );
};

export default WidgetRewards;
